<template>
  <v-container
    id="movimentacaoContasSemanal"
  >
    <div>
      <v-row v-if="loading">
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="12"
        >
          <div
            :style="styleObject"
            class="text-center"
          >
            <v-icon
              light
              class="custom-loader"
              :style="styleObject"
            >
              mdi-cached
            </v-icon>
            Carregando dados...
          </div>
        </v-col>
      </v-row>
      <v-row v-else-if="error">
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="12"
        >
          <div
            class="alert alert-danger"
          >
            {{ error }}
          </div>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="12"
        >
          <v-data-table
            id="headersMovimentacao"
            :headers="headersProjecaoSemanal"
            :items="projecaoSemanal"
            :items-per-page="projecaoSemanal.length"
            hide-default-footer
            disable-sort
            class="elevation-1"
            style="color: black"
          >
            <template v-slot:[`item.semana`]="{ item }">
              <td
                id="formaterDados"
              >
                {{ item.semana }}
              </td>
            </template>
            <template v-slot:[`item.saldo`]="{ item }">
              <td
                id="formaterDados"
                class="text-right"
              >
                {{ item.saldo }}
              </td>
            </template>
            <template v-slot:[`item.recebimento`]="{ item }">
              <td
                id="formaterDados"
                class="text-right"
              >
                {{ item.recebimento }}
              </td>
            </template>
            <template v-slot:[`item.pagamento`]="{ item }">
              <td
                id="formaterDados"
                class="text-right"
              >
                {{ item.pagamento }}
              </td>
            </template>
            <template v-slot:[`item.ch_abt`]="{ item }">
              <td
                id="formaterDados"
                class="text-right"
              >
                {{ item.ch_abt }}
              </td>
            </template>
            <template v-slot:[`item.dif`]="{ item }">
              <td
                id="formaterDados"
                class="text-right"
              >
                {{ item.dif }}
              </td>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
  import FluxoCaixa from '../../../../../services/fluxocaixa'
  import eventEmit from '../../core/EventoEmit'

  export default {
    name: 'ShowSaldoTotal',
    emits: [],
    components: {
    },
    data: () => ({
      styleObject: {
        color: '#4CAF50',
      },
      styleSaldoBancario: {
        color: '#4CAF50',
      },
      loading: false,
      error: null,
      select: [],
      projecaoSemanal: [],
      headersProjecaoSemanal: [
        { text: 'Semanas', value: 'semana', width: '120px', class: 'black--text title' },
        { text: 'S.A (+)', value: 'saldo', width: '80px', align: 'right', class: 'black--text title' },
        { text: 'R (+)', value: 'recebimento', width: '80px', align: 'right', class: 'black--text title' },
        { text: 'P (-)', value: 'pagamento', width: '90px', align: 'right', class: 'black--text title' },
        { text: 'CH ABT (-)', value: 'ch_abt', width: '80px', align: 'right', class: 'black--text title' },
        { text: 'DIF (=) ATUAL', value: 'dif', width: '100px', align: 'right', class: 'black--text title' },
      ],
    }),

    created () {
      eventEmit.$on('update-fluxo', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-fluxo', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (select) {
        this.select = select

        this.showDadosMovimentacaoSenamanalContas()
      },

      async showDadosMovimentacaoSenamanalContas () {
        this.loading = true

        this.projecaoSemanal = []

        await FluxoCaixa.showMovimentacaoSemanalContas(localStorage.username, localStorage.tokencontrato, this.select).then(resposta => {
          if (resposta.data.status) {
            this.projecaoSemanal = resposta.data.dadosMovimentacao.map((item) => {
              var listaMovimentacao = ({
                semana: item.semana,
                saldo: item.saldo !== '' ? parseFloat(item.saldo).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '',
                recebimento: parseFloat(item.recebimento).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                pagamento: parseFloat(item.pagamento).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                ch_abt: item.ch_abt !== '' ? parseFloat(item.ch_abt).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '',
                dif: parseFloat(item.dif).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                justificativa: item.justificativa,
              })

              return listaMovimentacao
            })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },
    },
  }
</script>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  #movimentacaoContasSemanal {
    max-width: 100%
  }

  #formaterDados {
    font-size: 11px
  }

  #justificativaId {
    margin: 0.7rem 0rem 0rem 0rem;
    border: double;
  }

  /* #linhaTabelaJustifiva {

  } */

  #tabelaJustificativa {
    margin: -0.5rem 0rem 0rem -1rem;
  }
</style>
